var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "email-editor-wrapper" } }, [
    _c("textarea", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loading,
          expression: "!loading",
        },
      ],
      ref: "emailEditor",
      attrs: { id: "email-editor-wrapper-textarea", name: "htmlBody" },
    }),
    _vm._v(" "),
    _c(
      "label",
      { attrs: { for: "email-editor-wrapper-textarea", hidden: "" } },
      [_vm._v("Email")]
    ),
    _vm._v(" "),
    _c("label", { attrs: { for: "foreColorPicker", hidden: "" } }, [
      _vm._v("Color Picker"),
    ]),
    _vm._v(" "),
    _c("label", { attrs: { for: "backColorPicker", hidden: "" } }, [
      _vm._v("Color Picker"),
    ]),
    _vm._v(" "),
    _c("label", { attrs: { for: "email-editor-id", hidden: "" } }, [
      _vm._v("Color Picker"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }